'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
* Default CSS class names
* @ignore
* @type {InputRangeClassNames}
*/
var DEFAULT_CLASS_NAMES = {
  activeTrack: 'input-range__track input-range__track--active',
  disabledInputRange: 'input-range input-range--disabled',
  inputRange: 'input-range',
  labelContainer: 'input-range__label-container',
  maxLabel: 'input-range__label input-range__label--max',
  minLabel: 'input-range__label input-range__label--min',
  slider: 'input-range__slider',
  sliderContainer: 'input-range__slider-container',
  track: 'input-range__track input-range__track--background',
  valueLabel: 'input-range__label input-range__label--value'
};

exports.default = DEFAULT_CLASS_NAMES;
module.exports = exports['default'];
//# sourceMappingURL=default-class-names.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-input-range/lib/js/input-range/default-class-names.js
// module id = 1280
// module chunks = 0